var _circle, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiabetes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#FFEFCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 113.235C62.5 92.3509 87.3189 60.5418 100.355 46.5366C100.726 46.1383 101.325 46.1145 101.726 46.4828C115.49 59.1418 141.667 89.1477 141.667 113.235C141.667 143.873 113.851 150 101.014 150C88.1757 150 62.5 139.788 62.5 113.235Z",
    fill: "url(#paint0_radial_997_9024)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.085 112.5C127.779 120.833 122.918 137.5 97.918 137.5",
    stroke: "#FFFAC7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.124 83.4333C110.124 83.378 110.079 83.3333 110.024 83.3333H94.1521C94.0969 83.3333 94.0521 83.378 94.0521 83.4333V93.947C94.0521 94.0022 94.0073 94.047 93.9521 94.047L83.4359 94.047C83.3807 94.047 83.3359 94.0917 83.3359 94.147L83.3359 110.018C83.3359 110.074 83.3807 110.118 83.4359 110.118H93.9521C94.0073 110.118 94.0521 110.163 94.0521 110.218V120.733C94.0521 120.788 94.0969 120.833 94.1521 120.833H110.024C110.079 120.833 110.124 120.788 110.124 120.733V110.218C110.124 110.163 110.168 110.118 110.224 110.118H120.736C120.791 110.118 120.836 110.074 120.836 110.018V94.147C120.836 94.0917 120.791 94.047 120.736 94.047L110.224 94.047C110.168 94.047 110.124 94.0022 110.124 93.947V83.4333Z",
    fill: "#FFD443"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.535 94.0479H98.647V98.6418H94.0469L94.0469 105.53H98.647V110.119H105.535V105.53H110.118V98.6418H105.535V94.0479Z",
    fill: "#FFA51F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_997_9024",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.917 141.667) rotate(-111.975) scale(128.053 190.41)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA51F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93982,
    stopColor: "#FFD443"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiabetes);
export default __webpack_public_path__ + "static/media/diabetes.2b37d8a7cc60efe35f3ab3eaf7673838.svg";
export { ForwardRef as ReactComponent };